import script from "./table-tag-tooltip.vue?vue&type=script&setup=true&lang=js"
export * from "./table-tag-tooltip.vue?vue&type=script&setup=true&lang=js"

import "./table-tag-tooltip.vue?vue&type=style&index=0&id=901b81b2&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-901b81b2"]])

export default __exports__